export default __webpack_public_path__ + "static/media/gitlab.5ead82a8.png";